(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationReinstateTravel',
	};

	var $form;

	var _updateReinstateAll;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Toggle new/existing reservation
		$form.find('.reinstate-all-components').on('change', function change(e) {
			if ($(this).val() === '1') {
				$form.find('.rr-toggle-vendor').prop('checked', true);
			} else {
				$form.find('.rr-toggle-vendor').prop('checked', false);
			}

			$form.find('.rr-toggle-vendor').trigger('change');
		});

		// Toggle vendor logic
		$form.find('.rr-toggle-vendor').on('change', function change(e) {
			var $checkbox           = $(this),
			    $reservation_vendor = $('#reservation-vendor-' + $checkbox.data('reservation-vendor-id'));

			if ($checkbox.prop('checked')) {
				$reservation_vendor.find('.rr-vendor:not(".rr-checkbox.rr-required-component")').prop('disabled', false);
				$reservation_vendor.find('.rr-hidden').val('1');
				$reservation_vendor.find('.rr-checkbox').prop('checked', true);
			} else {
				$reservation_vendor.find('.rr-checkbox').prop('checked', false);
				$reservation_vendor.find('.rr-hidden').val('0');
				$reservation_vendor.find('.rr-vendor').prop('disabled', true);
			}

			_updateReinstateAll();
		});

		// Toggle all components for vendor logic
		$form.find('.rr-toggle-components').on('change', function change(e) {
			var $checkbox           = $(this),
			    $reservation_vendor = $('#reservation-vendor-' + $checkbox.data('reservation-vendor-id'));

			if ($checkbox.prop('checked')) {
				$reservation_vendor.find('.rr-required-component').prop('disabled', true);
				$reservation_vendor.find('.rr-hidden').val('1');
				$reservation_vendor.find('.rr-checkbox:not(".rr-toggle-components")').prop('checked', true);
			} else {
				$reservation_vendor.find('.rr-checkbox:not(".rr-toggle-components")').prop('checked', false);
				$reservation_vendor.find('.rr-hidden').val('0');
				$reservation_vendor.find('.rr-required-component').prop('disabled', false);
			}

			_updateReinstateAll();
		});

		$form.find('.rr-component.rr-checkbox').on('change', function change(e) {
			var $checkbox           = $(this),
			    $reservation_vendor = $('#reservation-vendor-' + $checkbox.data('reservation-vendor-id'));

			if ($checkbox.prop('checked')) {
				if ($checkbox.hasClass('rr-required-component')) {
					$reservation_vendor.find('.rr-hidden').val('1');
				} else {
					$reservation_vendor.find('.rr-required-component').prop('checked', true);
					$reservation_vendor.find('.rr-required-component').prop('disabled', true);
				}

				if ($reservation_vendor.find('.rr-component.rr-checkbox:checked').length === $reservation_vendor.find('.rr-component.rr-checkbox').length) {
					$reservation_vendor.find('.rr-toggle-components').prop('checked', true);
				}
			} else {
				if ($checkbox.hasClass('rr-required-component')) {
					$reservation_vendor.find('.rr-hidden').val('0');
				} else if ($reservation_vendor.find('.rr-additional-component:checked').length === 0) {
					$reservation_vendor.find('.rr-required-component').prop('disabled', false);
				}

				$reservation_vendor.find('.rr-toggle-components').prop('checked', false);
			}

			_updateReinstateAll();
		});
	};

	_updateReinstateAll = function _updateReinstateAll()
	{
		if ($form.find('input:checkbox:not(:checked)').length === 0) {
			$('#reservationreinstatetravel-reinstate_all_components-1').prop('checked', true);
			$('#reservationreinstatetravel-reinstate_all_components-0').parent().removeClass('active');
			$('#reservationreinstatetravel-reinstate_all_components-1').parent().addClass('active');
		} else {
			$('#reservationreinstatetravel-reinstate_all_components-0').prop('checked', true);
			$('#reservationreinstatetravel-reinstate_all_components-0').parent().addClass('active');
			$('#reservationreinstatetravel-reinstate_all_components-1').parent().removeClass('active');
		}
	};

}(jQuery, window.Adzuki || {}));
